import React from 'react';
import { connect } from 'react-redux';
import { MicroFrontend } from '../../../../../packages/micro-frontend/src/index.js';
import { getConfigObject } from '../../../util/config';
import { isSectionCourseType } from '../../../util/util';

function SearchSectionsMicroFrontend({ permissions, course }) {
  const canReadClassGrades = permissions.course.grades.class.read;
  const { GRADEBOOK_SERVICE_URL, GRADEBOOK_CLIENT_URL } = getConfigObject();

  if (!canReadClassGrades) {
    return null;
  }
  return (
    <MicroFrontend
      name="SearchAcrossSections"
      clientHost={GRADEBOOK_CLIENT_URL}
      apiHost={GRADEBOOK_SERVICE_URL}
      courseId={course.id}
      courseShortId={course.data.short_id}
      isSectionManager={ isSectionCourseType(course.data.course_type) }
    />
  );
}


function mapStateToProps(state) {
  return {
    course: state.courses.course,
    permissions: state.courses?.course?.data?.productModel?.permissions,
  };
}

export default connect(mapStateToProps)(SearchSectionsMicroFrontend);
